import { render, staticRenderFns } from "./FlashNewsGeneralPane.vue?vue&type=template&id=93847168&"
import script from "./FlashNewsGeneralPane.vue?vue&type=script&lang=ts&"
export * from "./FlashNewsGeneralPane.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93847168')) {
      api.createRecord('93847168', component.options)
    } else {
      api.reload('93847168', component.options)
    }
    module.hot.accept("./FlashNewsGeneralPane.vue?vue&type=template&id=93847168&", function () {
      api.rerender('93847168', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/flashNews/FlashNewsGeneralPane.vue"
export default component.exports